export default "__VITE_ASSET__C331cgFx__"